<template>
    <div>
        <toggle-collapse>
            <DevicesListFilters :haseSupportFilter="true" :filterFor="report_type" :oldFilterData="request"
                @divicesFilterd="divicesFilterd" @merageFilterWithRequest="merageFilterWithRequest" />
        </toggle-collapse>

        <b-card style="position: relative">
            <div v-if="loading" class="loading_page">
                <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
            </div>

            <b-form @submit.prevent="getReport" class="">

                <b-row class="mt-2">

                    <!-- Contracts  -->
                    <b-col cols="6" md="6" sm="12">
                        <b-form-group :label="$t('Devices')" label-for="vi-devices-id">
                            <v-select multiple :close-on-select="false" v-model="request.devices"
                                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                                :options="[{ name: $t('all'), id: 'all' }, ...devices]" :reduce="d => d.id" />
                            <small v-if="errors && ('devices' in errors)" class="text-danger">
                                {{ $t(errors['devices'][0]) }}
                            </small>
                        </b-form-group>
                    </b-col>



                    <b-col v-if="report_type == 'report'" md="6" sm="12">
                        <!-- report range date -->
                        <b-form-group :label="$t('Select Start Date To End Date')" label-for="report-date" :state="null">
                            <flat-pickr v-model="rangeDate" :state="null" class="form-control"
                                :config="{ ...pickerOptions }" placeholder=" new Date()" />

                            <b-form-invalid-feedback v-if="errors && (('from' in errors) || ('to' in errors))"
                                :state="errors && (('from' in errors) || ('to' in errors)) ? false : null">
                                {{ ('from' in errors) ? errors['from'][0] : '' }}
                                {{ ('to' in errors) ? errors['to'][0] : '' }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>

                </b-row>
                <b-row>

                  

                   
                    <b-col cols="6">
                        <b-form-group :label="$t('hours less than')" label-for="hours">
                            <cleave id="dependsOn_duration" v-model="hours" class="form-control" :raw="false" :options="{
                                numeral: true,
                                numeralThousandsGroupStyle: 'thousand',
                            }" placeholder="10,000" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group :label="$t('distance less than')" label-for="distance">
                            <cleave id="dependsOn_duration" v-model="distance" class="form-control" :raw="false" :options="{
                                numeral: true,
                                numeralThousandsGroupStyle: 'thousand',
                            }" placeholder="10,000" />
                        </b-form-group>
                    </b-col>
                </b-row>



               


                <b-row>
                    <b-col cols="6">

                        <b-form-checkbox v-model="campLeave" :value="1" :unchecked-value="0">
                            {{ $t('depends on camp Leave') }}

                        </b-form-checkbox>
                        <b-row>
                            <small v-if="errors && ('conditions' in errors)" class="text-danger">
                                {{ $t(errors['conditions'][0]) }}
                            </small>

                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <!-- reset and submit -->
                    <b-col v-if="report_type == 'report'" cols="12">
                        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
                            {{ $t('Get Report') }}
                        </b-button>
                    </b-col>

                    <b-col v-if="report_type == 'setting'" cols="12">
                        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="button" variant="primary" class="mr-1"
                            @click="saveDialySetting('status')">
                            {{ $t('Save Setings') }}
                        </b-button>
                    </b-col>
                </b-row>


            </b-form>
        </b-card>

        <div v-if="report_data">
            <DataTable :report_data="report_data" :report_fields="report_fields"
                :filter_included_fields="filter_included_fields" :request="request" :errors="errors"
                :loading="dataTableloading || loading" :getReport="getReport" :total="total" :from="from" :to="to"
                :sortData="sortData" />

        </div>


    </div>
</template>
  
<script>

import {
    BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
    BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
    BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref, onMounted } from '@vue/composition-api'

import TotalAbsencePerDayLogic from './logic'
import DevicesListFilters from '../filters/DevicesListFilters.vue'
import FilterLogic from '@/views/reports/filters/filterLogic.js'
import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'

import { ReportSetting } from '@/views/reports/ReportSettings'

import DataTable from '@/views/reports/data-table/DataTable.vue'
import 'flatpickr/dist/plugins/monthSelect/style.css';

import Cleave from 'vue-cleave-component'

export default {
    name: 'TotalAbsencePerDayReport',
    components: {
        BRow,
        BCard, BFormCheckboxGroup, BTable, BPagination,
        BCol, BFormRadioGroup, BFormInvalidFeedback,
        BAlert,
        BFormGroup,
        BFormInput, flatPickr,
        BFormCheckbox,
        BInputGroup,
        BInputGroupPrepend,
        BForm,
        BButton,
        BTabs,
        BCardText,
        BTab,
        vSelect,
        OrbitSpinner,

        ToggleCollapse,
        DataTable,
        Cleave,
        DevicesListFilters

    },
    directives: {
        Ripple,
    },
    props: {
        report_type: {
            type: String,
            default: 'report'

        }
    },
    setup(props, { root, refs }) {

        const hourSearchoperations = ref([
            { id: ">", name: 'greater than' },
            { id: "<", name: "less than" },
            { id: "=", name: "equal" }

        ]);



        const rangeDate = ref('')

        const filter_included_fields = ['contract', 'contractor', 'absenceDays', 'absenceDevices', 'contractDevices', 'percent',];
        const report_fields = [
            {
                key: 'index',
                label: 'id',

            },
            {
                key: 'device.name',
                label: 'device',
                sortable: true
            },
            {
                key: 'device.owner.name',
                label: 'contractor',
                sortable: true
            },
            {
                key: 'device.contract.name',
                label: 'contract'
            },
            {
                key: 'distance',
                label: 'distance'

            },
            {
                key: 'hours',
                label: 'hours',

            },
            {
                key: 'date',
                label: 'date',

            },
            {
                key: 'campLeaveTime',
                label: 'campLeaveTime'
            },
            // {
            //     key: 'percent',
            //     label: 'percent',
            //     sortable: true
            // }




        ];

        const sortData = (data) => {
            sortBy.value = data.sortBy
            isSortDirDesc.value = data.isSortDirDesc
        }
        const { devices } = FilterLogic()
        const divicesFilterd = (data) => {
            devices.value = data;
        }
        const merageFilterWithRequest = (data) => {
            delete data['type']
            if (data['isSupport'] == "all") {
                delete data['isSupport']
                delete request.value.isSupport
            }
            Object.assign(request.value, data);
        }




        const tableRef = ref(null)

        const { report_data,
            request,
            hoursOperator,
            hours,
            distanceOperator,
            distance,
            campLeave,
            date, errors, loading, getReport, total, from, to, isSortDirDesc, sortBy, dataTableloading } = TotalAbsencePerDayLogic()


        const pickerOptions = {
            dateFormat: 'Y-m-d',
            defaultDate: [
                new Date(),
                new Date()
            ],

            enableTime: true,
            enableSeconds: true,
            defaultHour: 0,
            mode: 'range',
            time_24hr: true,
            onClose: function (selectedDates, dateStr, instance) {
                const date = dateStr.split(' to ')

                request.value.from = date[0]
                request.value.to = date[1]

            },

        }
        const perPageOptions = [5, 10, 25, 50, 100]
        const report_wrapper = ref(null)

        /// here use this form ass dialy report setting
        const toaster = (msg, variant = 'success', title = 'Success') => {
            root.$root.$bvToast.toast(
                root.$i18n.t(msg), {
                title: root.$i18n.t(title),
                variant,
                solid: true,
            })
        }
        const saveDialySetting = (reportName) => {
            let setting_data = request.value;
            delete setting_data.to;
            delete setting_data.from;

            ReportSetting.setSettings(reportName, setting_data).then((res) => {
                toaster('settigs saved succeffly!!', 'success!!')
            }).catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
        }
        onMounted(() => {
            if (props.report_type == 'setting') {
                ReportSetting.getSetting('status').then((res) => {
                    request.value = res;

                })
            }
        })
        //here end of   dialy report setting
        return {
            report_data, filter_included_fields, report_fields, total, from, to, rangeDate,
            tableRef,
            getReport,
            perPageOptions,


            pickerOptions,

            report_wrapper,
            request, date,
            loading,
            errors,
            merageFilterWithRequest,

            saveDialySetting,
            sortData,
            dataTableloading,
            hourSearchoperations,
            hoursOperator,
            hours,
            distanceOperator,
            distance,
            campLeave,
            devices,
            divicesFilterd

        }

    },

}
</script>
  
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
    overflow: hidden;
    transition: .35s height;
}
</style>
  